import React from 'react';
import VideoCard from '../../components/VideoCard/VideoCard';
import SessionCard from '../../components/SessionCard/SessionCard';

function SingleSession() {
    return (
        <div>
            {/* Video card */}
            <VideoCard />

            {/* Realated sessions filter by category */}
            {/* <div className="font-poppins px-10 pb-10 mx-auto lg:max-w-full md:max-w-3xl sm:max-w-full rounded-lg ">
                <h2 className="mt-6  mb-9 text-white text-3xl font-poppins font-bold">
                    Realated sessions
                </h2>
                <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-2 lg:grid-cols-3 gap-6 rounded-lg">
                    <SessionCard />
                    <SessionCard />
                    <SessionCard />

                </div>
                <div className="font-poppins space-x-4 space-y-4 text-center mt-10 mb-5">
                    <button
                        type="button"
                        className="px-5 py-2.5 rounded-lg text-sm tracking-wider fonr-poppins font-medium border border-text-paragraph-color outline-none  hover:bg-btn-color hover:border-btn-color text-gray-300 transition-all duration-300"
                    >
                        View All
                    </button>
                </div>
            </div> */}
        </div>
    );
}

export default SingleSession;
